import { post } from '@api/api-client';

interface LoginRequest {
  email: string;
  password: string;
}

export interface AppUserInfo {
  id: string;
  email: string;
  name: string;
  role: 'superadmin' | 'admin' | 'editor';
  country: string | null;
  /** True while the password came from an admin's reset rather than the holder. */
  mustChangePassword: boolean;
}

interface LoginResponse {
  success: boolean;
  user: AppUserInfo;
}

/** Authenticates the user. The JWT is set as an httpOnly cookie by the server. */
export async function login(credentials: LoginRequest): Promise<AppUserInfo> {
  const result = await post<LoginResponse>('/auth/login', credentials);
  return result.user;
}

/** Clears the session cookie on the server. */
export async function logout(): Promise<void> {
  await post<{ success: boolean }>('/auth/logout', {});
}

interface CheckEmailResponse {
  exists: boolean;
  needsPassword: boolean;
}

/** Check if an email is eligible for account creation. */
export async function checkEmail(email: string): Promise<CheckEmailResponse> {
  return post<CheckEmailResponse>('/auth/check-email', { email });
}

/** Set password for an account that does not have one. */
export async function setPassword(email: string, password: string): Promise<void> {
  await post<{ success: boolean }>('/auth/set-password', { email, password });
}
